import useLenis from "@/hooks/useLenis";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { MarqueeStrip } from "@/components/site/MarqueeStrip";
import { Manifesto } from "@/components/site/Manifesto";
import { Services } from "@/components/site/Services";
import { Experience } from "@/components/site/Experience";
import { Sectors } from "@/components/site/Sectors";
import { Process } from "@/components/site/Process";
import { CTASection } from "@/components/site/CTASection";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";

export default function Landing() {
  useLenis();
  return (
    <div className="grain relative bg-[#050505]" data-testid="landing-page">
      <Nav />
      <main>
        <Hero />
        <MarqueeStrip />
        <Manifesto />
        <Services />
        <Experience />
        <Sectors />
        <Process />
        <CTASection />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
